import { StyleSheet } from 'aphrodite';
import { charmGray } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	editor: {
		background: '#F9F9F9',
		border: '1px solid #ccc',
		height: 150,
		margin: '12px 0',
		width: '100%',
	},
	subHeader: {
		color: charmGray,
		fontSize: 14,
		marginBottom: 12,
	},
});
